import React from "react"
import { iProgressCardDataItem } from "./ProgressCard"
import { iGDM_CALC_STRUCTURE } from "../Structure"

export interface iResultsPanelCalculatorDataItem {
  key: string
  value: any
  title: string
  unit?: string
}

const calculateBMI = (height: number, weight: number) =>
  (weight * 10000) / height / height

const IsFormFilled: React.FC<{
  onTrue?: (dataForResults: (iResultsPanelCalculatorDataItem | null)[]) => any
  onFalse?: object
  data: {
    [id: string]: iProgressCardDataItem
  }
  calculatorStructure: iGDM_CALC_STRUCTURE
}> = ({ onTrue, onFalse, data, calculatorStructure }) => {
  let incompleteData = false

  let dataForResults: (iResultsPanelCalculatorDataItem | null)[] = Object.keys(
    data
  ).map(key => {
    if (incompleteData) return null
    const { value, error, warning } = data[key]
    if (!value || error || warning) {
      incompleteData = true
      return null
    }
    return {
      key,
      value,
      title: calculatorStructure[key].label,
      unit: calculatorStructure[key].unit,
    }
  })

  if (incompleteData) return <>{onFalse}</>

  const BMI = calculateBMI(
    data["height"].value,
    data["pre_pregnancy_weight"].value
  )
  dataForResults.push({
    key: "pre_pregnancy_BMI",
    value: BMI,
    title: "Pre-Pregnancy BMI",
    unit: "kg/m^2",
  })

  if (onTrue) return <>{onTrue(dataForResults)}</>

  return null
}

export default IsFormFilled
